import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { loginActions } from './app/store/user-login.reducer';
import { adminSettingActions } from './app/store/admin-setting.reducer';
import Routes from './app/routes';
import { NoSubscription } from './app/components/external/dashboard/no-subscription/no-subscription.component';
import Translation from './app/components/common/translation/translation.component';
import { TRANSLATIONS } from './app/utils/constant.utils';

class App extends Component {
    constructor(props) {
        super(props);

        this.state = {
            hasLoaded: false
        };
    }

    async componentDidMount() {
        await this.props.getUserAuth();
        await this.props.getAdminSetting();
        this.setState({
            hasLoaded: true
        });
    }

    render() {
        if (this.state.hasLoaded) {
            return (
                <div>
                    {Routes}
                </div>
            );
        }
        else {
            return (
                <div className="app-container-loading">
                    <NoSubscription title={<Translation locale={TRANSLATIONS.defaultLocaleLanguage} translationKey="loading" />} noOverviewContainer={true} />
                </div>
            );
        }
    }
}

export default connect(
    () => {
        return {};
    },
    dispatch => bindActionCreators(
        Object.assign({}, loginActions, adminSettingActions),
        dispatch
    )
)(App);
